'use client'

import { useEffect } from 'react'

export function InstallGlobalErrorListeners() {
	useEffect(() => {
		if (typeof globalThis.window !== 'undefined') {
			const handleError = (e: ErrorEvent) => {
				console.error('WINDOW_ERROR', {
					message: e.message,
					filename: e.filename,
					lineno: e.lineno,
					colno: e.colno,
					error: e.error,
					stack: e.error?.stack,
				})
			}

			const handleUnhandledRejection = (e: PromiseRejectionEvent) => {
				console.error('UNHANDLED_REJECTION', {
					reason: e.reason,
					stack: e.reason?.stack,
				})
			}

			globalThis.addEventListener('error', handleError)
			globalThis.addEventListener('unhandledrejection', handleUnhandledRejection)

			return () => {
				globalThis.removeEventListener('error', handleError)
				globalThis.removeEventListener('unhandledrejection', handleUnhandledRejection)
			}
		}
	}, [])

	return null
}
